import FetchAccount from '@Application/Accounts/Queries/FetchAccount';
import fetchAccount from '@Application/Accounts/fetchAccount';
import useStrictAuthenticatedUser from '@UI/Providers/AuthenticatedUserProvider/useStrictAuthenticatedUser';
import * as React from 'react';
import { useDispatch, useStoreQuery } from '@verclam/synapse';

/**
 * "Accueil — {account name}". Mounted only under `ACCOUNT_READ`; without an account it never
 * requests, and until the name arrives (or if it fails) the title stays "Accueil".
 */
const AccountTitle: React.FC = () => {
	const dispatch = useDispatch();
	const { user } = useStrictAuthenticatedUser();
	const accountId = user.account?.id ?? null;

	const { data: account } = useStoreQuery({
		selector: (state) => state.accountStore.account,
		stopOn: (value) => accountId === null || (value !== null && value.id === accountId),
		query: () => {
			if (accountId === null) {
				return Promise.resolve();
			}

			return dispatch(fetchAccount(new FetchAccount({ accountId })));
		},
		deps: [accountId],
	});

	const name = account !== null && account.id === accountId ? account.name : null;

	return <React.Fragment>{name === null ? 'Accueil' : `Accueil — ${name}`}</React.Fragment>;
};

export default AccountTitle;
